import { InlineReferenceValidationType } from 'stores/useInlineReferenceValidationToggleStore'
import { MessageReference } from 'types/Api'

import { InlineReferenceType } from './useInlineReferenceType'

type Props = {
  metadata: MessageReference['metadata']
  inlineReferenceValidationType: InlineReferenceValidationType
  referenceType: InlineReferenceType
}

const truncate = (text: string | null | undefined) =>
  text && text.length > 11 ? `${text.slice(0, 11)}…` : text

export const ReferenceLabel = ({ metadata, referenceType, inlineReferenceValidationType }: Props) => {
  const documentCategoryTitle = 'documentCategoryTitle' in metadata && metadata.documentCategoryTitle
  const categoryTitle = 'categories' in metadata && metadata.categories.length ? metadata.categories[0] : undefined

  const category = categoryTitle || documentCategoryTitle || null
  const title = metadata.title || ''

  const referenceTitleByType: Record<InlineReferenceType, string | null | undefined> = {
    'document-reference': inlineReferenceValidationType === 'type' ? category : truncate(title),
    'karnov-document': inlineReferenceValidationType === 'type' ? category : truncate(title),
    'attachment': truncate(title),
    'company-upload': truncate(title),
  }

  return <span className="truncate">{referenceTitleByType[referenceType]}</span>
}
